import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SettingsType } from '@Components/Settings/SettingsType';
import { RootState } from '@Services/redux/Store';
import { ISettingsState, initialSettingsState } from './State';

const SettingsSlice = createSlice({
    name: 'Settings',
    initialState: initialSettingsState,
    reducers: {
        openSettings(
            state: ISettingsState,
            action: PayloadAction<SettingsType>
        ) {
            state.settingsType = action.payload;
            state.isOpen = true;
        },
        closeSettings() {
            return initialSettingsState;
        },
    },
});

export const SettingsActions = SettingsSlice.actions;

export const isSettingsOpenState = (state: RootState) => state.settings.isOpen;
export const settingsTypeState = (state: RootState) =>
    state.settings.settingsType;

export default SettingsSlice.reducer;
